// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';


var scrolls = require("./scrolls")
;

var scrollToId = (
function scrollToId(id) {
  scrolls.scrollToId(id, {
	  align: "top",
	  duration: 1,
    offset: 0
  });
}
  );

var scrollToRef = (
function scrollToRef(ref) {
  scrolls.scrollToRef(ref, {
	  align: "top",
	  duration: 1,
    offset: 0
  });
}
  );

exports.scrollToId = scrollToId;
exports.scrollToRef = scrollToRef;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/scroller.re
// module id = 1662
// module chunks = 0